import React from 'react';
import LoadingOverlay from 'react-loading-overlay';

const LoadingScreen = ({ needsLoading = true }) => {
  return (
    <LoadingOverlay active={needsLoading} spinner animate>
      <div className="container" style={{ minHeight: '100vh' }} />
    </LoadingOverlay>
  );
};

export default LoadingScreen;
